import type { RevisionPageComputed } from '@gitbook/hive-core';
import { Icon } from '@gitbook/spine-icons';
import { Alert, LoadingIndicator } from '@gitbook/spine-react';

import { ComputedSourceIcon, ComputedSourceTitle } from '../../../../Components';

/**
 * Alert for a computed page.
 */
export function PageComputedHeaderAlert(props: {
    computedOrigin: RevisionPageComputed;
    /** If true, the alert will show a loading indicator */
    isComputing?: boolean;
}) {
    const { computedOrigin, isComputing = false } = props;
    const computedSource = computedOrigin.computed;

    if (computedSource.type === 'builtin:openapi') {
        return (
            <Alert
                kind="default"
                size="xsmall"
                className="mb-4"
                icon={
                    isComputing ? (
                        LoadingIndicator
                    ) : (
                        <ComputedSourceIcon source={computedOrigin.computed} />
                    )
                }
                details={
                    <>
                        This page is {isComputing ? 'being ' : ''}automatically generated from an
                        OpenAPI specification and can't be edited.
                    </>
                }
                action={{
                    kind: 'blank',
                    label: 'View OpenAPI specification',
                    trailingIcon: Icon.ArrowUpRight,
                    href: {
                        screen: {
                            type: 'openapi_spec',
                            spec: computedSource.dependencies.spec.ref.spec,
                        },
                    },
                }}
            />
        );
    }

    if (computedSource.type === 'builtin:translation') {
        return (
            <Alert
                kind="default"
                size="xsmall"
                className="mb-4"
                icon={
                    isComputing ? (
                        LoadingIndicator
                    ) : (
                        <ComputedSourceIcon source={computedOrigin.computed} />
                    )
                }
                details={
                    <>
                        This page is {isComputing ? 'being ' : ''}automatically translated and can't
                        be edited.
                    </>
                }
                action={{
                    kind: 'blank',
                    label: 'View translation',
                    trailingIcon: Icon.ArrowUpRight,
                    href: {
                        screen: {
                            type: 'translations',
                            view: 'overview',
                        },
                    },
                }}
            />
        );
    }

    return (
        <Alert
            kind="default"
            size="xsmall"
            className="mb-4"
            icon={
                isComputing ? (
                    LoadingIndicator
                ) : (
                    <ComputedSourceIcon source={computedOrigin.computed} />
                )
            }
            details={
                <>
                    This page is {isComputing ? 'being ' : ''}generated from{' '}
                    <ComputedSourceTitle source={computedOrigin.computed}>
                        {(props) => props.title}
                    </ComputedSourceTitle>{' '}
                    and can't be edited.
                </>
            }
        />
    );
}
